import { noop } from '@chakra-ui/utils';
import { useCallback, useState } from 'react';
import { MediaUploaderFileDetails } from './MediaUploaderFileDetails';
import { useMediaGallery } from './hooks';
import { Box, BoxBasedComponentProps } from '../Box';
import {
  EventMediaGallery,
  EventMediaGalleryProps,
} from '../EventMediaGallery';
import { Video } from '../MediaItemList';

export type MediaUploaderPreviewProps = BoxBasedComponentProps<
  'div',
  {
    files: Array<File | Video>;
    onDeleteFile?: (index: number, type?: string) => void;
    showDetails?: boolean;
  }
> &
  Pick<EventMediaGalleryProps, 'thumbnailType'>;

export const MediaUploaderPreview = ({
  files,
  onDeleteFile = noop,
  showDetails = false,
  thumbnailType,
  ...props
}: MediaUploaderPreviewProps) => {
  const [currentFileIndex, setCurrentFileIndex] = useState(0);

  const mappedFiles = useMediaGallery(files); // mapping items for event gallery
  const mediaGallery = [...mappedFiles];
  const selectedFile = mediaGallery[currentFileIndex];

  const handleDeleteFileClick = useCallback(() => {
    onDeleteFile(currentFileIndex);
  }, [currentFileIndex, onDeleteFile]);

  return (
    <Box position="relative" {...props}>
      {showDetails && selectedFile && (
        <MediaUploaderFileDetails
          mb={2}
          name={selectedFile.name}
          onDelete={handleDeleteFileClick}
          size={selectedFile.size}
        />
      )}
      <EventMediaGallery
        borderRadius="round"
        eventId="media-uploader-preview"
        media={mediaGallery}
        onSlide={setCurrentFileIndex}
        thumbnailType={thumbnailType}
        showDeviceBanner
      />
    </Box>
  );
};
